import { IInterval } from "../Context/Interval";
import { SystemContext, type ISystemContext } from "../Context/SystemContext";
import { CreateElement, Log, Safe, Scale } from "../MyHelpers";
import { UnregisterPixi, RegisterPixi } from "../PixiDebug";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { JackpotDisplayType, Settings } from "../Settings";
import * as PIXI from 'pixi.js'
import { GameViewAppPixi, OnCreatedEngineAppPixiCallbackHandler, OnDestroyEngineAppPixiCallbackHandler } from "./gameViewAppPixi";
import { FixedSizeFitContainer, ResponsivePaytable, ResponsiveSizeContainer, ResponsiveView } from "../../singlegame/ResponsiveHelpers";
import { singleApi } from "../../singlegame/SinglegameStartup";
import { GetOrientation, Orientation } from "../FitScreen";

export class GameViewAppPixiResponsive extends GameViewAppPixi {


	public constructor(resid: ResourceIdentifier, systemContext: ISystemContext) {
		super(resid, systemContext, "");

		// this.resid = resid.Add("GameViewEngineAppPixi_Responsive");		
		this.systemContext = systemContext.CreateSubContext("GameViewEngineAppPixi_Responsive");
		this.gameName = "";
		this.fixScreens = Settings.ScreenHeight * Settings.Screens;
		//if(Settings.Enable2plus1) this.fixScreens =  Settings.ScreenHeight * (Settings.Screens - 1);
		// this.view = CreateElement("div", {
		// 	classes: [`GameViewEngineAppPixi-SlotWindow-${gameName}-Responsive`], style: {
		// 		//display : "flex",
		//         width : "100%",
		//         height : this.fixScreens+"px",
		//         bottom : "0px",
		//         position : "absolute",
		// 		zIndex : "1",
		// 	}
		// });

		this.restoreWebGlInterval = this.systemContext.TimingContext().CreateInterval("restoreWebGlInterval", 500, async () => {
			let success = this.tryRecoverWebglContext();

			// success, stop timer
			if (!success) {
				this.recoverFailCount++;

				if (this.recoverFailCount == this.maxRecoverFailCount) {
					await singleApi.frontendError(`${this.resid.ID()} in ${this.recoverFailCount} tries`);
				}
			}
		});

	}
	protected responsiveView: ResponsiveView;
	// protected jackpotContainer: ResponsiveSizeContainer;
	protected baseGameContainer: ResponsiveSizeContainer;
	protected reelsContainer: FixedSizeFitContainer;
	protected panelContainer: ResponsiveSizeContainer;
	// protected jackpotView: FixedSizeContainer;
	protected payTableGrid: ResponsivePaytable = null;


	private createResponsiveElements(): void {
		this.responsiveView = new ResponsiveView(window.screen.availWidth, window.screen.availHeight, { color: 0x220000, name: 'responsive-view' });

		if (Settings.JackpotDisplayType == JackpotDisplayType.PaytableJackpotDisplay) {

			this.payTableGrid = new ResponsivePaytable({internalColumns: 3, internalRows: 3});
			this.app.stage.addChild(this.payTableGrid);
			
			this.baseGameContainer = new ResponsiveSizeContainer(0, 0.13, 1, 0.9, NaN, { color: 0x990000, name: 'base-game-container' });
			this.responsiveView.addChild(this.baseGameContainer);

			this.reelsContainer = new FixedSizeFitContainer(Scale.W(1920), Scale.H(1080), { color: 0xbb0000, name: 'reels-container' });
			this.baseGameContainer.addChild(this.reelsContainer);

			this.panelContainer = new ResponsiveSizeContainer(0, 0.85, 1, 0.15, NaN, { color: 0xff0000, name: 'panel-container' });
			this.responsiveView.addChild(this.panelContainer);
		}
		else {

			// this.jackpotContainer = new ResponsiveSizeContainer(0, 0, 1, 0.13, NaN,{color: 0x550000, secondaryColor: 0x005500, name: 'jackpot-container'});
			// this.responsiveView.addChild(this.jackpotContainer);

			// this.jackpotView = new FixedSizeContainer(Scale.W(1920), Scale.H(1080), {color: 0x550000, secondaryColor: 0x005500, name: 'jackpot-fixed-container'});
			// this.jackpotContainer.addChild(this.jackpotView);
			// this.jackpotView = new JackpotView(2.5, 0, 0, 1, 1, 6, {color: 0x550000, secondaryColor: 0x005500, name: 'jackpot-view'});
			// this.jackpotContainer.addChild(this.jackpotView);

			this.baseGameContainer = new ResponsiveSizeContainer(0, 0.13, 1, 0.87, NaN, { color: 0x990000, name: 'base-game-container' });
			this.responsiveView.addChild(this.baseGameContainer);

			this.reelsContainer = new FixedSizeFitContainer(Scale.W(1920), Scale.H(1080), { color: 0xbb0000, name: 'reels-container-basegame' });
			this.baseGameContainer.addChild(this.reelsContainer);
			this.reelsContainer.sortableChildren = true;

			this.panelContainer = new ResponsiveSizeContainer(0, 0.85, 1, 0.15, NaN, { color: 0xff0000, name: 'panel-container' });
			this.responsiveView.addChild(this.panelContainer);
		}

		// this.OnResize();


		this.app.stage.addChild(this.responsiveView);
		this.app.render();

	}

	public override GetView(): HTMLElement {
		return this.app.view;
	}

	public GetGridTemplate(): ResponsivePaytable{
		return this.payTableGrid;
	}
	public GetReelsGameResponsiveContainer(): FixedSizeFitContainer {
		return this.reelsContainer;
	}

	public GetBaseGameResponsiveContainer(): ResponsiveSizeContainer {
		return this.baseGameContainer;
	}
	
	public GetPanelContainer(): ResponsiveSizeContainer {
		return this.panelContainer;
	}

	public override GetAppView(): PIXI.Application<HTMLCanvasElement> {
		return this.app;
	}

	public override GetResponsiveView(): ResponsiveView {
		return this.responsiveView;
	}

	//update canvas render 
	public override Update() {
		this.app?.ticker?.update();
	}

	protected override created: boolean = false;
	public override Destroy() {

		this.InternalDestroy();
		this.created = false;
		this.restoreWebGlInterval.Stop();
	}

	protected override InternalDestroy() {

		if (!this.created) {
			Log.Debug(this.logGroup, `Destroy(): no app, not destroying anything`);
			return;
		}

		// Log.Debug(this.logGroup, `Destroy(): destroying`);

		// reset arrays
		//Safe(() => this.pixiCanvas = []);
		//Safe(() => this.pixiContainercanvas = []);

		if (this.app != null) {
			Safe(() => this.app.view.removeEventListener('webglcontextlost', this.webglcontextlostInstance));
			Safe(() => this.app.destroy(true, { children: true }));
			Safe(() => this.app?.view?.remove());
			Safe(() => UnregisterPixi(this.app, this.resid));
			Safe(() => {
				var currentContext = this.app.view.getContext("webgl");
				currentContext?.getExtension("WEBGL_lose_context").loseContext()
			});
			Safe(() => {
				var currentContext = this.app.view.getContext("webgl2");
				currentContext?.getExtension("WEBGL_lose_context").loseContext()
			});

			this.app = null;
		}

		this.OnDestroyCallback?.();
	}

	public override Create() {
		this.created = true;
		try {
			this.InternalCreate();
		}
		catch (ex) {
			this.restoreWebGlInterval.Start();
		}
	}

	protected override InternalCreate() {
		if (!this.created) {
			Log.Error(this.logGroup, `Create(): app not null, don't recreate`);
			return;
		}

		this.app = new PIXI.Application<HTMLCanvasElement>({
			width: window.innerWidth,
			height: window.innerHeight,
			backgroundAlpha: 0,
			resolution: window.devicePixelRatio, // <- key to fix pixelation
			autoDensity: true,
			//resizeTo: window,
			//resolution: 1
			// resolution: 1,
			//autoDensity: true,

		})
		document.body.appendChild(this.app.view);

		this.createResponsiveElements();

		this.app.stage.name = 'Responsive-pixi-app';

		// globalThis.__PIXI_APP__ = this.app;

		this.app.stage.accessibleChildren = true;
		this.app.stage.accessible = true
		this.app.stage.sortableChildren = true;
		//this.app.stage.interactive = true;
		this.app.stage.name = `GameViewEngineAppPixi-${this.gameName}`;

		//this.app.stage.interactive = true;
		this.app.stage.eventMode = 'static';
		this.app.stage.on("pointerdown", (ev: PIXI.FederatedPointerEvent) => {
			const p = ev.global;
			console.log("PointerDown: ", p);
		});

		RegisterPixi(this.app, this.resid);

		globalThis.__PIXI_APP__ = this.app;

		this.app.stop(); // use custom ticker	

		// this.view.appendChild(this.app.view);

		this.app.view.style.bottom = "0px";
		this.app.view.style.position = "relative";
		this.app.view.style.overflow = "hidden";
		this.OnCreatedCallback?.();
		this.OnResize();

	}

	protected override async tryRecoverWebglContext(): Promise<boolean> {
		if (this.created) return true;

		if (!this.created) {
			this.restoreWebGlInterval.Stop();
			this.recoverFailCount = 0;

			// app not created, don't care
			return true;
		}

		console.log(this.resid.ID() + " trying to recover");
		await singleApi.frontendError(`${this.resid.ID()}`);
		try {
			await singleApi.frontendError(`${this.resid.ID()}`);
			this.InternalDestroy();
			await singleApi.frontendError(`${this.resid.ID()}`);
		}
		catch (ex) {
			await singleApi.frontendError(`${this.resid.ID()}: ${ex.toString()}`);
		}

		try {
			// Log.Debug(this.logGroup, `tryRecoverWebglContext() ${this.resid.ID()} recreating`);
			await singleApi.frontendError(`${this.resid.ID()}`);
			this.InternalCreate();

			// all fine, stop timer
			this.restoreWebGlInterval.Stop();
			console.log(this.resid.ID() + " recover success");

			this.recoverCount++;
			this.restoreWebGlInterval.Stop();
			this.recoverFailCount = 0;

			await singleApi.frontendError(`${this.resid.ID()}`);
			await singleApi.frontendError(`${this.resid.ID()}, recover count: ${this.recoverCount}`);

			return true;
		}
		catch (ex) {
			console.log(this.resid.ID() + " error recovering", ex);

			// prevent spamming the backend
			if (this.recoverFailCount < this.maxRecoverFailCount) {
				await singleApi.frontendError(`${this.resid.ID()}, ${ex.toString()}`);

				if (ex.message.toLowerCase().includes("this browser does not support webgl")) {
					await singleApi.frontendError(`${this.resid.ID()}, error: ${ex.toString()}`);
				}
				else {
					await singleApi.frontendError(`${this.resid.ID()}, error: ${ex.toString()}`);
				}
			}
		}

		return false;
	};

	protected override async webglcontextlost() {
		Log.Error(this.logGroup, `Webgl context lost`);
		await singleApi.frontendError("Webgl context lost");

		// try recover right now, or start timer to try recover later
		let success = this.tryRecoverWebglContext();
		if (success) {
			// all good
			return;
		}

		// error recovering, start timer
		this.restoreWebGlInterval.Start();
	}
	// public override GetJackpotDisplayContainer(): ResponsiveSizeContainer {
	// 	return this.jackpotContainer
	// }

	public OnResize(): void {
		if (this.app == null) throw new Error("GameViewAppPixiResponsive.OnResize() app is null");

		// Limita el devicePixelRatio a un máximo de 2 para evitar resoluciones absurdas
		const dpr = Math.min(window.devicePixelRatio, 2);

		// Usa el tamaño real del contenedor o del window
		const width = window.innerWidth;
		const height = window.innerHeight;

		// Ajusta el tamaño del renderer y la resolución
		this.app.renderer.resolution = dpr;
		this.app.renderer.resize(width, height);

		// Ajusta el tamaño del canvas manualmente para evitar escalado CSS
		this.app.view.style.width = width + "px";
		this.app.view.style.height = height + "px";

		this.responsiveView.setAvailableSize(width, height);
		this.payTableGrid?.Resize();

		if (Settings.JackpotDisplayType == JackpotDisplayType.PaytableJackpotDisplay){
			
			if (GetOrientation() == Orientation.Landscape){
				this.baseGameContainer.percentX = 0.025;
				this.baseGameContainer.percentY = 0.13;
				this.baseGameContainer.percentWidth = 0.95;
				this.baseGameContainer.percentHeight = 0.87;
				return;
			}
			
			this.baseGameContainer.percentY = 0.4
			this.baseGameContainer.percentX = 0.025;
			this.baseGameContainer.percentWidth = 1;
			this.baseGameContainer.percentHeight = 0.5;
		}

	}
	public Created(): boolean {
		return this.created;
	}

	protected override webglcontextlostInstance: () => void = this.webglcontextlost.bind(this);
	// public override OnCreatedCallback: OnCreatedEngineAppPixiCallbackHandler = null;

	// public override OnDestroyCallback: OnDestroyEngineAppPixiCallbackHandler = null;
}

// export type OnCreatedEngineAppPixiCallbackHandler = () => void;
// export type OnDestroyEngineAppPixiCallbackHandler = () => void;